import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useScene } from '../../hooks';
import { ReferencePositionInputGroup } from '../common/inputGroups/ReferencePositionInputGroup';
import { SizeInputGroup } from '../common/inputGroups/SizeInputGroup';
import { SidebarButtons } from './SidebarButtons';
import { DataProps } from './props/DataProps';
import { StyleProps } from './props/StyleProps';
import { SidebarAccordion } from './sidebarAccordion/SidebarAccordion';

export const SidebarContent = () => {
  const scene = useScene();
  const [pseudoclass, setPseudoclass] = useState<string>('none');

  useEffect(() => {
    setPseudoclass('none');
  }, [scene.selectedElementIDs]);

  return (
    <>
      <Content $leftScrollbar>
        <h1>Properties</h1>

        <ReferencePositionInputGroup />
        <SizeInputGroup />
        <DataProps />

        <Separator />

        <h2>General Style</h2>
        <StyleProps pseudoclass={pseudoclass} />

        <Separator />

        <h2>States Style</h2>
        <SidebarAccordion pseudoclass={pseudoclass} />
      </Content>

      <SidebarButtons
        pseudoclass={pseudoclass}
        setPseudoclass={setPseudoclass}
      />
    </>
  );
};

const Separator = styled.div`
  width: 100%;
  height: 1px;
  margin: 20px 0;
  background: linear-gradient(
    90deg,
    transparent,
    var(--input-border-color) 10%,
    var(--input-border-color) 90%,
    transparent
  );
`;

const Content = styled.div<{ $leftScrollbar?: boolean }>`
  user-select: none;
  box-sizing: border-box;
  width: 100%;
  min-width: 250px;
  height: calc(100% - 20px);

  font-size: 12px;
  font-weight: 300;

  padding: 0 17px;
  margin: 10px 0;
  overflow-y: auto;

  ${({ $leftScrollbar }) =>
    $leftScrollbar &&
    `
    direction: rtl;
  & > * {
    direction: ltr;
  }
    `}

  h1 {
    color: var(--text-color-secondary);
    font-size: 18px;
    font-weight: 300;
    text-align: center;
    padding: 10px 0;
  }
  h2 {
    color: var(--text-color-secondary);
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }
`;
